var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pg-badge"},[_vm._t("default"),_vm._v(" "),(!_vm.hidden)?_c('span',{staticClass:"pg-badge-count",style:(_setup.maxStyle)},[_vm._v(_vm._s(_setup.text))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }